/* eslint-disable react-hooks/exhaustive-deps */
import { ICurrentEditType, ILandingSection, ILink, LANDING_TYPE_CONTENT, LinksFeedContent } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import { LinkEditForm } from "../editors/link/SingleLinkDialog"
import { useEffect, useState } from "react"

/* Protopia Ecosystem component */
export interface ILinkItemEditFormProps {
   onChange: ( val: any, field: string ) => void
   data: any
}
const LinkItemEditForm = (props: ILinkItemEditFormProps): JSX.Element => {
    
    const getLinkData = (): ILink => {
        if(!!curEditModal?.isNew) {
            return {} as ILink
        }
        const section: ILandingSection      = useLandingStore.getState().currentLanding.sections.find((s:ILandingSection) => s.id === curEditModal?.sectionId) || {}
        const meat: LinksFeedContent        = (section.data.find((mt) => mt.type === LANDING_TYPE_CONTENT.LINKS_FEED) || {}) as LinksFeedContent
        const item                          = meat.items[ props.data.order || 0 ]
        return item
    } 
    const curEditModal: ICurrentEditType    = useLandingStore( (state: ILandingStore) => state.curEditModal )
    const [value, setValue]                 = useState<ILink>( getLinkData() )
    const [isLoading, setIsLoading]         = useState<boolean>( false )
    
    useEffect(() => {
        // setValue( getLinkData() )
    }, [ curEditModal, props.data ])
    
    const onChange = (val: any, field: string, dop: any="") => {
        const newVal = {
            ...value,
            [field]: val
        } 
        setValue(newVal)
        props.onChange( val, field )
    }

    return <LinkEditForm
        value={value}
        isLoading={isLoading}        
        onChange = {onChange}
        setValue={setValue}
        setIsLoading={setIsLoading}
    />
}
export default LinkItemEditForm